/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_Soft_Owl_GazeInputs */

const en_fast_soft_owl_gaze = /** @type {(inputs: Fast_Soft_Owl_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surveys enabled`)
};

const de_fast_soft_owl_gaze = /** @type {(inputs: Fast_Soft_Owl_GazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragungen aktiv`)
};

/**
* | output |
* | --- |
* | "Surveys enabled" |
*
* @param {Fast_Soft_Owl_GazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fast_soft_owl_gaze = /** @type {((inputs?: Fast_Soft_Owl_GazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_Soft_Owl_GazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_soft_owl_gaze(inputs)
	return de_fast_soft_owl_gaze(inputs)
});